module.exports = __webpack_public_path__ + "img/processing.8897c939.png";